<template>
  <div id="data-view">
    <div class="main-header">
      <div class="mh-right">
        <!-- <dv-border-box-2
            style="width: 120px; height: 50px; line-height: 50px; text-align:center;margin-left:200px;"
        >综合管理</dv-border-box-2>-->
      </div>
    </div>

    <dv-border-box-1 class="main-container">
      <dv-border-box-13 class="left-chart-container" v-if="type=='sbj'">
        <Left-Chart-11 />
        <Left-Chart-21 v-if="region!='yt'" />
        <BottomCharts11 />
        <BottomCharts12 />
        <RightChart1 />
      </dv-border-box-13>
      <dv-border-box-13 class="left-chart-container" v-if="type=='qs'">
        <Left-Chart-12 />
        <Left-Chart-22 v-if="region!='yt'" />
        <BottomCharts21 />
        <BottomCharts22 />
      </dv-border-box-13>

      <dv-border-box-13 class="left-chart-container" v-if="type=='hj'">
        <Left-Chart-13 />
        <Left-Chart-23 v-if="region!='yt'" />
        <BottomCharts31 />
        <BottomCharts32 />
      </dv-border-box-13>
    </dv-border-box-1>
  </div>
</template>

<script>
import LeftChart11 from './LeftChart11'
import LeftChart12 from './LeftChart12'
import LeftChart13 from './LeftChart13'
import LeftChart21 from './LeftChart21'
import LeftChart22 from './LeftChart22'
import LeftChart23 from './LeftChart23'
import LeftChart3 from './LeftChart3'
import CenterCmp from './CenterCmp'

import RightChart1 from './RightChart1'
import RightChart2 from './RightChart2'

import BottomCharts11 from './BottomCharts11'
import BottomCharts12 from './BottomCharts12'
import BottomCharts21 from './BottomCharts21'
import BottomCharts22 from './BottomCharts22'
import BottomCharts31 from './BottomCharts31'
import BottomCharts32 from './BottomCharts32'

export default {
  name: 'DataView',
  computed: {
    type() {
      return getQueryString('type')
    },
    region() {
      return getQueryString('region')
    }
  },
  components: {
    LeftChart11,
    LeftChart12,
    LeftChart13,
    LeftChart21,
    LeftChart22,
    LeftChart23,
    LeftChart3,
    CenterCmp,
    RightChart1,
    BottomCharts11, BottomCharts12, BottomCharts21,
    BottomCharts22, BottomCharts31, BottomCharts32
  },
  data() {
    return {}
  }
}
function getQueryString(name) {
  if (!name) return null;
  // 查询参数：先通过search取值，如果取不到就通过hash来取
  var after = window.location.search;
  after = after.substr(1) || window.location.hash.split('?')[1];
  // 地址栏URL没有查询参数，返回空
  if (!after) return null;
  // 如果查询参数中没有"name"，返回空
  if (after.indexOf(name) === -1) return null;
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  // 当地址栏参数存在中文时，需要解码，不然会乱码
  var r = decodeURI(after).match(reg);
  // 如果url中"name"没有值，返回空
  if (!r) return null;
  return r[2];
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  color: #000;
  display: flex;
  flex-direction: column;

  .main-header {
    height: 40px;
    justify-content: space-between;
    text-align: center;

    .mh-left {
      font-size: 20px;
      color: rgb(1, 134, 187);

      a:visited {
        color: rgb(1, 134, 187);
      }
    }

    .mh-middle {
      width: 100%;
      font-size: 25px;
      color: #000;
      padding-top: 20px;
    }

    .mh-left,
    .mh-right {
      width: 450px;
    }
  }

  .main-container {
    height: calc(~"100% - 80px");

    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }

  .left-chart-container {
    width: 100%;
    height: 100%;
    padding: 5px;
    box-sizing: border-box;

    .border-box-content {
      flex-direction: column;
    }
  }

  .right-main-container {
    width: 66%;
    padding-left: 5px;
    box-sizing: border-box;
  }

  .rmc-top-container {
    height: 80%;
    display: flex;
  }

  .rmctc-left-container {
    width: 45%;
  }

  .rmctc-right-container {
    width: 45%;
  }

  .rmc-bottom-container {
    height: 35%;
  }

  .rmctc-chart-1,
  .rmctc-chart-2 {
    height: 50%;
  }
}
</style>
